module.exports = __webpack_public_path__ + "static/media/bg-sign-up.fb3011bc.svg";